export interface ArticleDetail {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  duration: string;
  views: string;
  date: string;
  description: string;
  content: string;
  tags: string[];
}

export const articleDetails: Record<string, ArticleDetail> = {
  'feat-1': {
    id: 'feat-1',
    title: '2026夏季时尚穿搭指南｜轻熟风日常搭配分享',
    category: '时尚穿搭',
    categorySlug: 'shishang-chuanda',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20stylish%20woman%20in%20fashionable%20summer%20outfit%2C%20soft%20natural%20lighting%2C%20minimalist%20warm%20cream%20background%2C%20editorial%20lifestyle%20photography%2C%20clean%20composition&width=1200&height=675&seq=article-feat-1&orientation=landscape',
    duration: '08:24',
    views: '128.6万',
    date: '2026-08-08',
    description: '夏季轻熟风搭配技巧全解析，从职场到约会一网打尽，教你穿出高级感。',
    content: '炎炎夏日，如何穿出既清爽又不失优雅的轻熟风格？本期视频为你带来2026夏季最实用的穿搭指南。从基础单品的挑选到整体搭配的巧思，每一个细节都经过精心考量。轻熟风的精髓在于简约而不简单，通过质感面料、柔和色调和恰到好处的剪裁，展现女性独特的优雅气质。无论是职场通勤、周末约会还是闺蜜聚会，都能找到适合的搭配方案。快来一起学习，让你的夏季穿搭充满高级感！',
    tags: ['夏季穿搭', '轻熟风', '时尚搭配', '日常穿搭'],
  },
  'feat-2': {
    id: 'feat-2',
    title: '海边度假写真｜夏日清新胶片风人像摄影',
    category: '生活写真',
    categorySlug: 'shenghuo-xiezhen',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20at%20tropical%20beach%20resort%2C%20summer%20vacation%20vibe%2C%20soft%20warm%20sunlight%2C%20film%20photography%20style%2C%20natural%20pose%2C%20clean%20ocean%20background&width=1200&height=675&seq=article-feat-2&orientation=landscape',
    duration: '12:15',
    views: '96.3万',
    date: '2026-08-07',
    description: '跟随镜头感受海边度假的惬意时光，清新胶片风格人像写真拍摄全记录。',
    content: '海风轻拂，阳光正好。本期生活写真带你走进热带海岛的度假时光。采用胶片风格的拍摄手法，捕捉每一个自然流露的笑容和瞬间。从清晨的海边漫步到傍晚的沙滩落日，每一个画面都充满了夏日的清新与浪漫。拍摄过程不仅展示了美丽的风景，更记录下了旅行中那些不经意的美好。无论你是摄影爱好者还是旅行达人，都能从中获得灵感，学会如何用镜头记录生活中的美好时刻。',
    tags: ['海边写真', '人像摄影', '胶片风格', '旅行记录'],
  },
  'feat-3': {
    id: 'feat-3',
    title: '古典舞《惊鸿》完整版｜国风舞蹈才艺展示',
    category: '才艺展示',
    categorySlug: 'caiyi-zhanshi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20female%20dancer%20in%20traditional%20Chinese%20dance%20costume%2C%20classical%20dance%20performance%2C%20flowing%20silk%20ribbons%2C%20soft%20dramatic%20lighting&width=1200&height=675&seq=article-feat-3&orientation=landscape',
    duration: '06:48',
    views: '215.7万',
    date: '2026-08-06',
    description: '原创古典舞作品《惊鸿》，融合传统与现代元素，展现东方女性的柔美与力量。',
    content: '一曲《惊鸿》，演绎东方美学的极致魅力。这支原创古典舞作品以中国传统舞蹈为基础，融合现代编舞元素，通过舞者的身姿、手势和表情，讲述了关于美丽与自由的故事。柔美的水袖、灵动的步伐、深情的眼神，每一个细节都经过精心打磨。舞蹈配乐选用传统乐器与现代音效的巧妙结合，营造出如梦如幻的舞台氛围。这支舞不仅是才艺的展示，更是对中国传统文化的致敬与创新诠释。',
    tags: ['古典舞', '国风舞蹈', '才艺展示', '文化传承'],
  },
  'feat-4': {
    id: 'feat-4',
    title: '日系清透妆容教程｜新手也能轻松掌握',
    category: '美容美妆',
    categorySlug: 'meirong-meizhuang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20applying%20natural%20makeup%2C%20Japanese%20style%20clean%20look%2C%20soft%20daylight%20by%20window%2C%20minimalist%20vanity%20setup&width=1200&height=675&seq=article-feat-4&orientation=landscape',
    duration: '15:32',
    views: '89.2万',
    date: '2026-08-05',
    description: '零基础也能学会的日系清透裸妆教程，步骤详细讲解，打造自然好气色。',
    content: '日系妆容一直以清透自然著称，深受亚洲女性的喜爱。本期美妆教程将手把手教你打造完美的日系清透妆容。从妆前保湿到底妆选择，从眼妆技巧到唇色搭配，每一个步骤都有详细的讲解和演示。不需要高超的化妆技术，只要掌握了这些简单的小技巧，每个人都能拥有自然通透的好气色。教程中使用的大部分产品都是平价好用的开架品牌，学生党和化妆新手也能轻松入手。一起变美吧！',
    tags: ['日系妆容', '化妆教程', '清透裸妆', '新手友好'],
  },
  'feat-5': {
    id: 'feat-5',
    title: '居家瑜伽跟练｜30分钟全身燃脂塑形',
    category: '健身运动',
    categorySlug: 'jianshen-yundong',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fit%20woman%20doing%20yoga%20pose%20in%20bright%20minimalist%20home%20studio%2C%20morning%20sunlight%2C%20light%20wooden%20floor%2C%20white%20walls%2C%20wellness%20lifestyle&width=1200&height=675&seq=article-feat-5&orientation=landscape',
    duration: '32:10',
    views: '176.5万',
    date: '2026-08-05',
    description: '适合初学者的居家瑜伽课程，30分钟高效燃脂，坚持练习塑造完美体态。',
    content: '想要在家就能高效燃脂塑形吗？这节30分钟的瑜伽跟练课程就是为你准备的！课程由专业瑜伽教练精心设计，从热身开始，逐步过渡到核心训练和全身拉伸。每个体式都有清晰的讲解和示范，即使是瑜伽新手也能轻松跟上。课程注重呼吸与动作的配合，在燃脂的同时帮助放松身心。坚持每天练习，不仅能改善体态、塑造线条，还能提升身体的柔韧性和平衡感。铺开瑜伽垫，让我们一起开始吧！',
    tags: ['瑜伽', '居家健身', '燃脂塑形', '初学者'],
  },
  'feat-6': {
    id: 'feat-6',
    title: '成都美食探店｜隐藏在巷子里的地道川味',
    category: '旅行美食',
    categorySlug: 'luxing-meishi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20enjoying%20food%20at%20traditional%20Chinese%20restaurant%2C%20warm%20ambient%20lighting%2C%20wooden%20interior%2C%20steaming%20dishes%20on%20table&width=1200&height=675&seq=article-feat-6&orientation=landscape',
    duration: '18:45',
    views: '143.8万',
    date: '2026-08-04',
    description: '带你走遍成都大街小巷，探寻最地道的川味美食，每一口都是惊喜。',
    content: '成都，一座来了就不想走的城市，更是一座让吃货流连忘返的美食天堂。本期视频避开那些游客扎堆的网红店，带你深入成都的老街巷弄，探寻只有本地人才知道的隐藏美食。从清晨的一碗担担面，到深夜的串串香，每一家店都有着自己的故事和坚守。红油翻滚的火锅、麻辣鲜香的水煮鱼、软糯回甜的赖汤圆……跟着镜头，感受最地道的成都味道，开启一场舌尖上的麻辣之旅！',
    tags: ['成都美食', '美食探店', '川菜', '旅行美食'],
  },
};

export const getRelatedVideos = (currentId: string, categorySlug: string) => {
  const relatedIds = {
    'shishang-chuanda': ['hot-1', 'hot-7', 'latest-1', 'cat-f1'],
    'shenghuo-xiezhen': ['hot-2', 'latest-2', 'cat-l1', 'cat-l2'],
    'caiyi-zhanshi': ['hot-3', 'hot-8', 'latest-3', 'cat-t1'],
    'meirong-meizhuang': ['hot-4', 'latest-4', 'cat-b1', 'cat-b2'],
    'jianshen-yundong': ['hot-5', 'cat-fit1', 'cat-fit2', 'cat-fit3'],
    'luxing-meishi': ['hot-6', 'cat-tr1', 'cat-tr2', 'cat-tr3'],
  };

  const ids = relatedIds[categorySlug] || [];
  return ids.filter((id) => id !== currentId).slice(0, 4);
};